import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';
import React from 'react';

export const HelperMEP = ({ isOpen, handleClose }) => {
  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          borderBottom: 1,
          marginBottom: 3,
          display: 'flex',
          gap: 4,
          alignItems: 'center',
          fontSize: 24,
          color: 'primary.main',
        }}
      >
        <HelpOutlineIcon fontSize="large" />
        Aide de la programmation d&apos;un déploiement
      </DialogTitle>

      <DialogContent
        sx={{
          maxHeight: '75vh',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="h6" color="primary">
            Descriptions des statut de Pandora
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, ml: 2 }}>
            <Typography color="primary">
              <strong>Active:</strong>
            </Typography>
            <Typography>
              Quand Pandora est actif, un formulaire est disponible aux super
              administrateurs pour lancer le déploiement. La date de début est
              obligatoire, la date de fin est opionnelle. Confirmer le
              formulaire de déploiement lance une alerte à tous les utilisateurs
              et un message slack dans le canal PANDORA pour prévenir du
              déploiement. Confirmer le formulaire change le status de Pandroa
              en <strong> En attente de déploiement</strong>.
            </Typography>

            <Divider sx={{ my: 1 }} />

            <Typography color="primary">
              <strong>En attente de déploiement:</strong>
            </Typography>
            <Typography>
              Quand Pandora est en attente de déploiement, Les utilisateur et
              les super utilisateurs ont accès à la plateforme. Seuls les super
              administrateurs peuvent changer la date de début et de fin du
              déploiement, lors de la modifiaction des dates une alerte de
              rappel et un message slack dans le canal PANDORA informe les
              utilisateurs. Il est aussi possible d&apos;annuler le déploiement
              ce qui fait passer le status de Pandora en <strong>Active</strong>{' '}
              et alerte les utilisateurs de l&apos;annulation. Les super
              administrateurs doivent lancer le déploiement sur l&apos;interface
              pour passer le status de Pandora en{' '}
              <strong>En déploiement</strong>, ce changement de statut
              déconnecte tout les utilisateurs quel que soit le rôle. La date de
              début est mise à jour.
            </Typography>

            <Divider sx={{ my: 1 }} />

            <Typography color="primary">
              <strong>En déploiement:</strong>
            </Typography>
            <Typography>
              Quand Pandora est en déploiement, seuls les super administrateurs
              peuvent se connecter. Seuls les super administrateurs ont accès à
              l&apos;interface permettant de finaliser le déploiement. Finaliser
              le déploiement change le status en <strong>Active</strong>. La
              date fin est mise à jour.
            </Typography>
            <Divider sx={{ my: 1 }} />

            <Typography color="primary">
              <strong>Motif de déploiement:</strong>
            </Typography>
            <Typography>
              {' '}
              Quand le motif de déploiement est HOT FIX, la release note ne peut
              pas être renseignée. La release note, si elle existe, est envoyée
              au canal Slack PANDORA à la fin du déploiement.
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{ p: 3, display: 'flex', justifyContent: 'space-between' }}
      >
        <Button
          variant="outlined"
          color="info"
          onClick={handleClose}
          sx={{ marginRight: 2 }}
        >
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
};
